import { Link } from "react-router-dom";
import type { SiteWithCategory } from "@/types/nav";
import { formatDate } from "@/lib/navData";
import { getTone } from "@/lib/tone";

export default function MiniSiteCard({ site }: { site: SiteWithCategory }) {
  const tone = getTone(site.tone);

  return (
    <article className="group flex flex-col p-4 md:p-5 rounded-xl border border-background-200 bg-background-50 hover:border-primary-300 transition-colors">
      <div className="flex items-start gap-3">
        <Link
          to={`/detail/${site.id}`}
          className={`w-11 h-11 rounded-lg bg-gradient-to-br ${tone.gradient} text-background-50 flex items-center justify-center font-heading font-bold shrink-0`}
        >
          {site.logoText}
        </Link>
        <div className="min-w-0 flex-1">
          <div className="flex items-center justify-between gap-2">
            <Link
              to={`/detail/${site.id}`}
              className={`font-heading font-semibold text-sm text-foreground-950 ${tone.hoverText} transition-colors cursor-pointer truncate`}
            >
              {site.name}
            </Link>
            <span className="text-xs text-foreground-400 whitespace-nowrap shrink-0">
              {formatDate(site.addedAt)}
            </span>
          </div>
          <p className="text-xs text-foreground-500 mt-0.5">{site.subCategory}</p>
        </div>
      </div>

      <p className="text-sm text-foreground-600 mt-3 line-clamp-2 leading-relaxed flex-1">
        {site.description}
      </p>

      <div className="flex items-center gap-2 mt-4">
        <Link
          to={`/detail/${site.id}`}
          className="flex-1 text-center px-3 py-2 rounded-md border border-background-200 text-xs text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
        >
          查看详情
        </Link>
        <a
          href={site.url}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 text-center px-3 py-2 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-xs font-medium transition-colors cursor-pointer whitespace-nowrap"
        >
          立即访问
          <i className="ri-external-link-line ml-1" />
        </a>
      </div>
    </article>
  );
}